import { useCallback, useEffect, useRef } from "react";
import type { NativeScrollEvent, NativeSyntheticEvent } from "react-native";
import type { ScrollView } from "tamagui";

import { isPositive } from "~/utils/is-positive";
import { useHistory } from "./use-history";

export const useAutoScroll = () => {
  const { prev, next, set, reset } = useHistory(0);
  const scrollRef = useRef<ScrollView | null>(null);

  const lastScrollPosition = useRef(0);

  const onScroll = useCallback(
    (event: NativeSyntheticEvent<NativeScrollEvent>) => {
      const newPosition = event.nativeEvent.contentOffset.y;
      lastScrollPosition.current = newPosition;
    },
    [],
  );

  const resetOnClose = useCallback(() => {
    reset();
    lastScrollPosition.current = 0;
  }, [reset]);

  useEffect(() => {
    if (prev === undefined) return;
    if (prev >= next) return;
    if (prev === 0) return;

    const diff = Math.floor(next - prev);

    if (isPositive(diff) && scrollRef.current) {
      scrollRef.current.scrollTo({
        y: lastScrollPosition.current + diff,
        animated: true,
      });
    }
  }, [prev, next]);

  return {
    trackHeightValue: set,
    scrollRef,
    resetOnClose,
    onScroll,
  };
};
